import {Component, ElementRef, OnDestroy, ViewChild} from '@angular/core';
import {SankeyStore} from "./store/sankey-store";
import {Chart} from "chart.js/auto";
import {Subscription} from "rxjs";
import {ErrorCodes} from "../../../../common/enums/states/error-codes";
import {CommonModule} from "@angular/common";
import {ErrorMessageComponent} from "../../../../common/components/error-message/error-message.component";

@Component({
  selector: 'app-sankey-chart',
  templateUrl: './sankey-chart.component.html',
  styleUrls: ['./sankey-chart.component.css'],
  providers: [SankeyStore],
  imports: [
    CommonModule,
    ErrorMessageComponent
  ]
})
export class SankeyChartComponent implements OnDestroy {
  subscription: Subscription = new Subscription()
  sankeyChart: Chart<"sankey"> | undefined;
  protected readonly ErrorCodes = ErrorCodes;
  private sankeyChartElement!: ElementRef<HTMLCanvasElement>;

  constructor(
    public sankeyStore: SankeyStore
  ) {
    this.subscribeToStore()
  }

  @ViewChild('sankeyChart', {static: false}) set contentSankeyChart(content: ElementRef<HTMLCanvasElement>) {
    if (content) {
      this.sankeyChartElement = content;
    }
  }

  subscribeToStore() {
    this.subscription.add(this.sankeyStore.updateNotifier.subscribe(() => {
      this.drawChart()
    }))
  }

  drawChart() {
    // Define the chart to be drawn. Chartjs is used here.
    if (this.sankeyChart != undefined) {
      this.sankeyChart?.destroy()
    }
    if (this.sankeyChartElement === undefined) {
      return;
    }

    if (this.sankeyStore.getDataset() == undefined) {
      return
    }

    this.sankeyChart = new Chart<"sankey">(this.sankeyChartElement.nativeElement, {
      type: 'sankey',
      data: this.sankeyStore.getDataset(),
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          tooltip: {
            enabled: true,
            callbacks: {
              title: function (context) {
                // @ts-ignore
                return context[0].dataset.labels[context[0].raw!.from] + " -> " + context[0].dataset.labels[context[0].raw!.to]
              },
              label: function (context) {
                // @ts-ignore
                return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(context.raw!.flow);
              }
            }
          }
        }
      }

    });

  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
    if (this.sankeyChart != undefined) {
      this.sankeyChart?.destroy()
    }
  }
}
